import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Com token armazenado (mesmo expirado) mantém a área logada; sem token redireciona ao login. */
@Injectable()
export class AuthGuard {

  constructor(private authService: NbAuthService, private router: Router) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.getToken().pipe(
      map((token: NbAuthJWTToken) => {
        const raw = token?.getValue?.();
        if (raw != null && String(raw).trim() !== '') {
          return true;
        }
        return this.router.parseUrl('/auth/login');
      }),
    );
  }
}
